import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '@/integrations/supabase/client';

export type AdminRole = 'admin' | 'moderator' | null;

export const useAdminRole = () => {
  const { user, loading: authLoading } = useAuth();
  const [role, setRole] = useState<AdminRole>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRole = async () => {
      // Wait for auth to finish loading before checking role
      if (authLoading) {
        return;
      }
      
      if (!user) {
        setRole(null);
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .in('role', ['admin', 'moderator'])
        .maybeSingle();

      if (error) {
        console.error('Error fetching role:', error);
        setRole(null);
      } else if (data) {
        setRole(data.role as AdminRole);
      } else {
        setRole(null);
      }
      setLoading(false);
    };

    fetchRole();
  }, [user, authLoading]);

  const isAdmin = role === 'admin';
  const isSupport = role === 'moderator';
  const hasAccess = isAdmin || isSupport;

  return { role, isAdmin, isSupport, hasAccess, loading };
};
